module.exports = __webpack_public_path__ + "static/img/4.cd072af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/4.png
// module id = qHB7
// module chunks = 0